import { SET_FILTER_VALUES, SET_SEARCHDATA, SET_SELECTED_MAP_ICONS,SET_LOADER_STATE,ADD_SEARCHDATA, SET_SEARCHDATA_COUNT,
		RESET_SEARCHDATA, FETCH_DISTINCT_BRANDS } from "../actions/types";

const initialState = {
	searchData: [],
	sitesLoaded: true,
	filter_values: [],
	selectedMapIcons: [],
	loaderState:false,
	distinctBrands:[]
};

export default (state = initialState, action) => {
	switch (action.type) {
		case SET_FILTER_VALUES: {
			return { ...state, filter_values: action.payload };
		}
		case SET_SEARCHDATA: {
			return { ...state, searchData: action.payload };
		}
		case SET_SELECTED_MAP_ICONS: {
			return { ...state, selectedMapIcons: action.payload };
		}
		case SET_LOADER_STATE:{
			return { ...state, loaderState:action.payload};
		}
		case ADD_SEARCHDATA:{
			return { ...state, searchData: state.searchData.concat(action.payload)}
		}
		case SET_SEARCHDATA_COUNT: {
			return { ...state, searchDataCount: action.payload};
		}

		case FETCH_DISTINCT_BRANDS: {
			return { ...state, distinctBrands: action.payload};
		}

		case RESET_SEARCHDATA:{
			return {...state, searchData:[]}
		}
		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/v3/reducers/filterReducer.js